<template>
  <div class="mini-calendar__filters">
    <!-- Only render the date picker if not in month view -->
    <MiniCalendarCalendar v-if="!isMonthView" @month-changed="handleMonthChange" />
    <div
      class="mini-calendar__filters"
      role="region"
      aria-label="Event Filters"
    >
      <MiniCalendarCollpase
        v-if="!isMonthView"
        :title="date_filter.title"
        :uuid="'date-acc'"
        :categories="date_filter.list"
        option="radio"
      />
      <template v-if="categorylist.keys ? categorylist.keys : []">
          <MiniCalendarCollpase
          v-for="(key, index) in categorylist.keys"
          :key="'category-' + key"
          :title="categorylist.data[key].title"
          :uuid="index"
          :categories="categorylist.data[key].terms"
          :categoryId="categorylist.data[key].vid"
          />
      </template>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import MiniCalendarCalendar from "./mini-calendar-calendar.vue";
import MiniCalendarCollpase from "./collapse/mini-calendar-collapse";
import { DATE_FILTER } from "@/utils/config";
import { mapGetters, mapActions } from "vuex";
import { getFilteredEvents } from "./../api";
import { debounce } from "lodash";

export default {
  name: "MiniCalenderFilters",
  components: {
    MiniCalendarCalendar,
    MiniCalendarCollpase,
  },
  computed: {
    ...mapGetters(["categorylist", "date_range", "selectedMonth", "selectedCategories", "isMonthView"]),
    isMonthView() {
      return this.$store.state.isMonthView;
    },

  },
  data() {
    return {
      date_filter: DATE_FILTER,
      isMobile: window.innerWidth < 768,
      isFilterHidden: true,
      activeCategories: {}
    };
  },

  methods: {
    handleMonthChange(selectedMonth) {
      this.$emit('month-changed', selectedMonth);
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    initializeSelectedCategories() {
      // Initialize local state with selected categories from Vuex
      this.activeCategories = { ...this.selectedCategories };
    },
    applyFilters() {
      this.setLoading(true);
      const queryString = Object.entries(this.$store.state.selectedCategories || {})
        .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
        .join("&");
      const finalQueryString = queryString || "";
      const searchTerm = this.search || "";
      const selectedMonth = this.$store.getters.selectedMonth || moment().format("YYYY-MM");
      this.setSelectedMonth(selectedMonth);
      const startDate = moment(selectedMonth, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
      const endDate = moment(selectedMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD");

      getFilteredEvents(
        startDate,
        endDate,
        finalQueryString,
        1,
        searchTerm
      )
        .then((response) => {
          this.setEventList({
            eventlist: response.data ? response.data : [],
            total: response.query.total,
          });
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },

    ...mapActions(["setEventList", "setFilter", "setLoading", "setSelectedMonth"]),
    ...mapGetters(["search", "filter", "date_range"]),
  },
  updateCategorySelection(categoryId, selectedTerms) {
      // Update the local state and Vuex state when a category is selected
      this.activeCategories[categoryId] = selectedTerms;
      this.$store.dispatch("updateSelectedCategories", { key: categoryId, terms: selectedTerms });
  },

  mounted() {
    this.debouncedResize = debounce(this.handleResize, 200);
    window.addEventListener("resize", this.debouncedResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  watch: {
  selectedMonth: function (newMonth) {
    if (newMonth) {
      const startDate = moment(newMonth, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
      const endDate = moment(newMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
      this.setDateRange({
        type: "custom_range",
        start: startDate,
        end: endDate,
      });
    }
  },
},

};
</script>
